import React, {useMemo, useState} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {Button, Card, Col, Form, Modal, Row, Select, Tooltip} from "antd";
import ConnectionSelector from "../ConnectionSelector";
import InfiniteScrollTable from "../../../../../components/infinite-scroll-table";
import {
    GUTTER_MD,
    GUTTER_XS,
    MARGIN_MD, MARGIN_SM,
    MODAL_WIDTH_XL,
    SPAN_FULL,
    SPAN_HALF,
    TABLE_COL_MIN_WIDTH_ID
} from "../../../../../styles/constants";
import {BUTTON_DETAIL, BUTTON_EXPORT} from "../../../../../styles/buttons";
import {
    QUERY_HEIGHT,
    SELECT_TABLE_VIEW_CHOICES,
    sqlDoesNotContainBlacklistedKeywords,
    sqlIsValid,
    TABLE_CHOICE,
    TABLE_VIEW_CHOICE
} from "./utils";
import {DEFAULT_TABLE_HEIGHT} from "../../../../../components/infinite-scroll-table/contants";
import DataflowCubeSelector from "../DataflowCubeSelector";
import UnionBuilder from "../UnionBuilder";
import {
    readDatasetBuilderWizardQueryDatasetPreviewRows,
    readDatasetBuilderWizardQueryPreviewRows
} from "../../actions";
import {connect} from "react-redux";
import ZoomableHighlightedTextarea from "../../../../../components/zoomable-highlighted-textarea";
import {appendQueryTableViewDatasetBuilder, datasetBuilderUpdateInDb, replaceQueryDatasetBuilder} from "../actions";
import ObjectPreview from "./ObjectPreview";
import {getFilterObjFromViewerObj} from "../../../../../utils/filter";
import {MODIFY_MODE} from "../../utils";


const mapStateToProps = state => ({
    connections: state.scenes.mappingHandler.datasetBuilder.index.connections,
    connId: state.scenes.mappingHandler.datasetBuilder.index.connId,
    rows: state.scenes.mappingHandler.datasetBuilder.index.rows,
    query: state.scenes.mappingHandler.datasetBuilder.unionModalProps.query,
    tableViews: state.scenes.mappingHandler.datasetBuilder.index.tableViews,
    updateInDbData: state.scenes.mappingHandler.datasetBuilder.unionModalProps.updateInDbData,
    blackListQueryWord: state.config.dataManagement.blackListQueryWord,
});

const mapDispatchToProps = dispatch => ({
    fetchTableViewPreviewRows: ({connId, limit, page, query, searchText, filters, sortCol, sortByDesc, rows}) =>
        dispatch(readDatasetBuilderWizardQueryPreviewRows(connId, limit, page, query, searchText, getFilterObjFromViewerObj(rows && rows.columns, searchText, filters), sortCol, sortByDesc)),
    fetchDatasetPreviewRows: ({connId, limit, page, query, searchText, filters, sortCol, sortByDesc, rows}) =>
        dispatch(readDatasetBuilderWizardQueryDatasetPreviewRows(connId, limit, page, query, searchText, getFilterObjFromViewerObj(rows && rows.columns, searchText, filters), sortCol, sortByDesc)),
    appendQuery: (connId, tableName, dbType) => dispatch(appendQueryTableViewDatasetBuilder(connId, tableName, dbType)),
    modifyQuery: (query) => dispatch(replaceQueryDatasetBuilder(query)),
    resetQuery: () => dispatch(replaceQueryDatasetBuilder("")),
    updateInDb: (connId, query) => dispatch(datasetBuilderUpdateInDb(connId, query))
});

const FirstStep = ({
                       t,
                       form,
                       modalInfo,
                       rows,
                       fetchTableViewPreviewRows,
                       fetchDatasetPreviewRows,
                       query,
                       appendQuery,
                       modifyQuery,
                       resetQuery,
                       connections,
                       connId,
                       tableViews,
                       updateInDb,
                       updateInDbData,
                       disableModify,
                       blackListQueryWord,
                   }) => {
    const [showUnionModal, setShowUnionModal] = useState(false);
    const [isRowsModalVisible, setIsRowsModalVisible] = useState(false);
    const selectedConnection = useMemo(() => (connections || []).find(item => item.entityId === connId), [connections, connId]);
    const [tableViewSelection, setTableViewSelection] = useState(TABLE_VIEW_CHOICE);
    const visibleTableViews = useMemo(() => tableViewSelection !== TABLE_VIEW_CHOICE ? (tableViews || []).filter(item => tableViewSelection === TABLE_CHOICE ? item.type === "table" : item.type === "view") : tableViews, [tableViews, tableViewSelection])
    const [tableViewTempQuery, setTableViewTempQuery] = useState("");

    return (
        <Form>
            <Row type="flex" gutter={GUTTER_MD}>
                <Col span={SPAN_HALF}>
                    <Card>
                        <Row type="flex" gutter={GUTTER_MD}>
                            <Col span={SPAN_FULL}>
                                <Form.Item>
                                    <ConnectionSelector
                                        disableModify={disableModify || modalInfo.mode === MODIFY_MODE}/>
                                </Form.Item>
                            </Col>
                            <Col span={SPAN_HALF}>
                                <Form.Item>
                                    <Select
                                        showSearch
                                        filterOption={(inputValue, {props}) =>
                                            props.title.toLowerCase().includes(inputValue.toLowerCase())
                                        }
                                        disabled={!form.getFieldValue('connection_Id') || disableModify}
                                        value={tableViewSelection}
                                        onChange={(val) => setTableViewSelection(val)}
                                    >
                                        {SELECT_TABLE_VIEW_CHOICES.map((choice) => {
                                            return (
                                                <Select.Option
                                                    key={choice.value}
                                                    value={choice.value}
                                                    title={choice.label}
                                                >
                                                    {choice.label}
                                                </Select.Option>
                                            );
                                        })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            {selectedConnection && selectedConnection.dbType === 1 ? (
                                <Col span={SPAN_HALF}>
                                    <Form.Item>
                                        <DataflowCubeSelector/>
                                    </Form.Item>
                                </Col>) : null}
                        </Row>
                        <div style={{paddingTop: GUTTER_XS}}>
                            <InfiniteScrollTable
                                height={DEFAULT_TABLE_HEIGHT + QUERY_HEIGHT - 20}
                                data={!form.getFieldValue('connection_Id') ? [] : visibleTableViews}
                                getRowKey={({id}) => id}
                                columns={[{
                                    title: t('data.datasetBuilder.type.shortLabel'),
                                    dataIndex: 'type',
                                    minWidth: TABLE_COL_MIN_WIDTH_ID
                                }, {
                                    title: t('data.datasetBuilder.name.shortLabel'),
                                    dataIndex: 'name',
                                    minWidth: TABLE_COL_MIN_WIDTH_ID
                                }
                                ]}
                                actions={[
                                    {
                                        ...BUTTON_DETAIL,
                                        title: t('commons.actions.detailReadOnly.title'),
                                        onClick: (row) => {
                                            setTableViewTempQuery(`SELECT *
                                                                   from ${row.name}`)
                                            setIsRowsModalVisible(true)
                                        }
                                    },
                                    {
                                        ...BUTTON_EXPORT,
                                        title: t('commons.actions.query.title'),
                                        onClick: (item) => appendQuery(connId, item.name, selectedConnection ? selectedConnection.realDbType || selectedConnection.dbType : null),
                                        disabled: disableModify
                                    }
                                ]}
                                searchBarSpan={SPAN_FULL}
                            />
                        </div>
                    </Card>
                </Col>
                <Col span={SPAN_HALF}>
                    <Card>
                        <Row type="flex" gutter={GUTTER_MD} >
                            <Col>
                                <Tooltip
                                    title={t("scenes.mappingHandler.DatasetBuilder.tooltip.unionButton")}>
                                    <Button
                                        type="primary"
                                        style={{marginBottom: MARGIN_SM}}
                                        onClick={() => setShowUnionModal(true)}
                                        disabled={!connId || disableModify}
                                    >
                                        {t('scenes.mappingHandler.DatasetBuilder.wizard.step.first.unionButton')}
                                    </Button>
                                </Tooltip>
                            </Col>
                            <Col>
                                <Tooltip
                                    title={t("scenes.mappingHandler.DatasetBuilder.tooltip.extraColumnsButton")}>
                                    <Button
                                        type="primary"
                                        style={{marginBottom: MARGIN_SM}}
                                        disabled={!connId || !query || disableModify}
                                        onClick={() => {
                                            if (!sqlDoesNotContainBlacklistedKeywords(query, blackListQueryWord.split("|"), t)) return;
                                            if (!sqlIsValid(query, t)) return;
                                            updateInDb(connId, query)
                                        }}
                                    >
                                        {t('scenes.mappingHandler.DatasetBuilder.wizard.step.first.UpdateInDBButton')}
                                    </Button>
                                </Tooltip>
                            </Col>
                            <Col>
                                <Tooltip
                                    title={t("scenes.mappingHandler.DatasetBuilder.tooltip.clearQueryButton")}>
                                    <Button
                                        type="default"
                                        style={{marginBottom: MARGIN_SM}}
                                        onClick={() => {
                                            resetQuery();
                                            updateInDb(connId, '')
                                        }}
                                        disabled={!query}
                                    >
                                        {t('scenes.mappingHandler.DatasetBuilder.wizard.step.first.clearQueryButton')}
                                    </Button>
                                </Tooltip>
                            </Col>
                            <Col>
                                <Tooltip
                                    title={t("scenes.mappingHandler.DatasetBuilder.tooltip.datasetPreviewButton")}>
                                    <Button
                                        type="default"
                                        style={{marginBottom: MARGIN_SM}}
                                        onClick={() => {
                                            setTableViewTempQuery("");
                                            if (!sqlDoesNotContainBlacklistedKeywords(query, blackListQueryWord.split("|"), t)) return;
                                            if (!sqlIsValid(query, t)) return;
                                            setIsRowsModalVisible(true);
                                        }}
                                        disabled={!connId || !query}
                                    >
                                        {t('scenes.mappingHandler.DatasetBuilder.wizard.step.first.preview')}
                                    </Button>
                                </Tooltip>
                            </Col>
                            <Col>
                                <Tooltip
                                    title={t("scenes.mappingHandler.DatasetBuilder.wizard.step.first.timePeriodAlertModal.title")}>
                                    <Button
                                        type="default"
                                        style={{marginBottom: MARGIN_SM}}
                                        onClick={() => {
                                            Modal.info({
                                                title: t("scenes.mappingHandler.DatasetBuilder.wizard.step.first.timePeriodAlertModal.title"),
                                                content: t("scenes.mappingHandler.DatasetBuilder.wizard.step.first.timePeriodAlertModal.content"),
                                            });
                                        }}
                                    >
                                        {t('scenes.mappingHandler.DatasetBuilder.wizard.step.first.timePeriodAlert')}
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row>
                        <div style={{
                            fontFamily: 'monospace',
                            marginTop: MARGIN_MD,
                            marginBottom: MARGIN_MD,
                            height: QUERY_HEIGHT
                        }}>
                            <ZoomableHighlightedTextarea
                                onChange={modifyQuery}
                                value={query}
                                disabled={disableModify}
                                modalProps={{bodyStyle: {height: "75vh"}, width: MODAL_WIDTH_XL}}
                                onClear={resetQuery}
                            />
                        </div>
                        <InfiniteScrollTable
                            data={updateInDbData || []}
                            searchBarSpan={SPAN_FULL}
                            columns={[{
                                title: t('data.datasetBuilder.name.shortLabel'),
                                dataIndex: "name",
                                minWidth: TABLE_COL_MIN_WIDTH_ID
                            }
                            ]}
                        />
                    </Card>
                </Col>
            </Row>
            <UnionBuilder isModalVisible={showUnionModal} onModalHide={() => setShowUnionModal(false)}
                          modalInfo={modalInfo}/>
            <ObjectPreview
                rows={rows}
                isRowsModalVisible={isRowsModalVisible}
                onRowsModalHide={() => {
                    setIsRowsModalVisible(false);
                    setTableViewTempQuery("");
                }}
                fetchRows={!!tableViewTempQuery ? fetchTableViewPreviewRows : fetchDatasetPreviewRows}
                connId={connId}
                query={tableViewTempQuery || query}
            />
        </Form>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(FirstStep)
